









































import { Component, Prop, Vue } from 'vue-property-decorator'
import { TriggeredAction } from '@/api/model/triggered-action'
import { ActionType } from '@/api/types'

@Component
export default class CreateAutoActionVerticalStep3 extends Vue {
    @Prop({ required: true }) readonly currentStep!: number
    @Prop({ default: false }) readonly existing!: boolean
    @Prop({ required: true }) readonly value!: TriggeredAction

    get actionTypeLabel() {
        return this.$t(`action.type.${this.value.actionType}`)
    }

    get delayUnitLabel() {
        return this.$tc(`virtualColleague.autoAction.avatarHeader.delayUnit.${this.value.delayUnit}`, this.value.delayQuantity)
    }

    get actionAssignedToTypeLabel() {
        if (this.value.actionAssignToType === null) {
            return this.$t(`virtualColleague.autoAction.actionAssignTo`)
        } else {
            return this.$t(`forms.triggered_action_form.action-assigned-to-type-options.${ this.value.actionAssignToType }`)
        }
    }

    get isAddToPipeline(): boolean {
        return this.value.actionType === ActionType.ADD_TO_PIPELINE
    }
}
